export { Fragment } from 'react';
import parseProps from '@theme-ui/parse-props';
import { jsx as jsx$1, jsxs as jsxs$1 } from '@emotion/react/jsx-runtime';

var jsx = function jsx(type, props, key) {
  return jsx$1(type, parseProps(props), key);
};

var jsxs = function jsxs(type, props, key) {
  return jsxs$1(type, parseProps(props), key);
};

export { jsx, jsxs };